import { createClient } from "graphql-ws";
import type { Client } from "graphql-ws";
import { apiWsUrl } from "../helpers/api-base";
import { withAuthToken } from "../helpers/auth";

interface ConstantsShape {
  Site: { Name: string };
  LimitOptions: number[];
  graphqlWSClient: Client | null;
  graphqlWSClientUrl: string | null;
  init: () => void;
  dispose: () => void;
}

const Constants: ConstantsShape = {
  Site: {
    Name: "Instabot",
  },
  LimitOptions: [10, 20, 50, 100],
  graphqlWSClient: null,
  graphqlWSClientUrl: null,
  init: () => {
    // WebSockets can't carry an Authorization header, so the session token is
    // passed as a query param; the server's onConnect checks it.
    const url = withAuthToken(apiWsUrl("/api"));
    if (Constants.graphqlWSClientUrl === url && Constants.graphqlWSClient) {
      return;
    }
    if (Constants.graphqlWSClient) {
      Constants.graphqlWSClient.dispose();
    }

    Constants.graphqlWSClientUrl = url;
    Constants.graphqlWSClient = createClient({
      url,
      keepAlive: 60000,
      on: {
        connected: () => {
          window.dispatchEvent(new Event("instabot-api-connected"));
        },
      },
    });
  },
  // Tear down the live client (e.g. on logout) so a stale token doesn't keep a
  // subscription socket open.
  dispose: () => {
    if (Constants.graphqlWSClient) {
      Constants.graphqlWSClient.dispose();
      Constants.graphqlWSClient = null;
      Constants.graphqlWSClientUrl = null;
    }
  },
};

export default Constants;
